<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <!-- Application buttons -->
        <div class="box info-box">
          <div class="box-header text-center">
            <h3 class="box-title"><i class="fa fa-info"></i> Cibil Details</h3>
          </div>
          <div class="box-body text-center">
            <a class="btn btn-app box-widget box-red" @click="viewInfo">
              <i class="fa fa-address-card-o"></i> High Mark
            </a>
            <a class="btn btn-app box-widget box-red" @click="viewInfo"> 
              <i class="fa fa-address-card"></i> Equifax
            </a>
            <a class="btn btn-app box-widget box-red" @click="viewInfo">
              <i class="fa fa-id-card-o"></i> Experian
            </a>
            <a class="btn btn-app box-widget box-red" @click="viewInfo">
              <i class="fa fa-id-card"></i> TransUnion
            </a>
            <!-- <a class="btn btn-app">
              <i class="fa fa-check-square-o"></i> Check
            </a> -->
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    viewInfo () {
      Swal.fire('Cibil Score!', '<b>For Cibil Feature Please Contact Or whatsapp on +91-7017109788, 9911551344.</b>', 'info')
    }
  }
}
</script>
<style scoped>
  table.v-table thead th {
      font-size: 20px;
 }
 .widget-user .widget-user-header {
    height: 70px;
 }
 .box-widget {
   border-radius:10px;
   box-shadow: 0px 0px 4px gray;
 }
 .widget-user-desc-b {
   padding-bottom: 10px;
 }
 .box-red {
    background-color:#ec1c22;
    color: #fff;
  }
  .widget-user .widget-user-header {
    height: 85px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// Cibil.vue?b9a32504